import React from 'react';
import styled from 'styled-components';
import { FormRow } from '@zocdoc-frontend-common/styles-grid';
import Textarea from '@zocdoc-mezzanine/components-textarea';
import { labelSmall } from '@zocdoc-mezzanine/foundations-typography';
import { SexAssignedAtBirthTooltip } from 'src/Booking/components/DoctorNotes/SexAssignedAtBirthTooltip';

/**
 * @param {string} doctorNotes
 * @param {function(notes: string): void} onEnterDoctorNotes
 * @param {function(): void} trackSelectDoctorNotes
 * @returns {JSX.Element}
 * @constructor
 */
export class DoctorNotesView extends React.Component {
    static defaultProps = {
        doctorNotes: '',
    };

    handleChangeTextArea = (ev) => {
        const { onEnterDoctorNotes } = this.props;
        return onEnterDoctorNotes(ev.target.value);
    };

    render() {
        const { doctorNotes, trackSelectDoctorNotes } = this.props;

        return (
            <FormRow
                className="exclude-from-playback"
                data-test="doctor-notes-form-row"
            >
                <SectionTitle
                    data-test="doctor-notes-label"
                    htmlFor="doctor-notes-textarea"
                >
                    Notes for the doctor's office (optional){' '}
                    <SexAssignedAtBirthTooltip />
                </SectionTitle>
                <Textarea
                    aria-label="Notes for the doctor's office."
                    data-test="doctor-notes-text-area"
                    id="doctor-notes-textarea"
                    onChange={this.handleChangeTextArea}
                    onFocus={trackSelectDoctorNotes}
                    value={doctorNotes}
                    rows={3}
                />
            </FormRow>
        );
    }
}

const SectionTitle = styled.label`
    display: flex;
    ${labelSmall}
    margin-bottom: 4px;
`;
